export default {
	name: 'TreatmentsView'
}